module.exports = __webpack_public_path__ + "static/media/driveamerica-3.3fff5ba6.jpg";